const alert2 = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M7.25 10.69h1.5v2h-1.5zm0-7.69h1.5v6.34h-1.5z"/></svg>',
};

export { alert2 as default };
